import React from 'react';

const ChallengeTypeText = () => {
    return <></>;
};

export default ChallengeTypeText;
